module.exports = __webpack_public_path__ + "static/media/depoimentos-bg.c03e8b1d.svg";